export interface ShippingRate {
  carrier: string
  service: string
  fees: number
  package_type?: string
  zone?: string
}

export interface CalculatorRequest {
  ship_from: string
  ship_to: string
  package_type: 'custom' | 'flat'
  carrier?: string
  dimensions?: {length: number; width: number; height: number}
  weight?: number
}

export const CALCULATOR_CARRIERS = ['usps', 'ups', 'fedex'] as const

export const WEIGHT_UNITS = ['oz', 'lb', 'kg'] as const

export const ZIP_CODE_PATTERN = /^\d{5}(-\d{4})?$/

export const isValidZip = (value: string): boolean => ZIP_CODE_PATTERN.test(value.trim())

export const isPositiveNumber = (value: string): boolean => {
  const num = parseFloat(value)
  return !isNaN(num) && num > 0
}

export const handleZipChange = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 9)
  return digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits
}

export const normalizeZip = (value: string): string => value.trim().replace(/\D/g, '').slice(0, 5)

export const numericOnly = (v: string): boolean => !v || /^\d*\.?\d*$/.test(v)
